import { render, staticRenderFns } from "./InformeLink.vue?vue&type=template&id=100cc54c&scoped=true&"
import script from "./InformeLink.vue?vue&type=script&lang=js&"
export * from "./InformeLink.vue?vue&type=script&lang=js&"
import style0 from "./InformeLink.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./InformeLink.vue?vue&type=style&index=1&id=100cc54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100cc54c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VApp,VCard,VCardActions,VCardText,VCol,VForm,VRow,VSpacer,VTextarea,VToolbar,VToolbarTitle})
